export const TextSizeType = {
    small: 'small',
    medium: "medium",
    big: "big"
}